const sizeClasses = {
  hero: "heading-hero",
  section: "heading-section",
  row: "heading-row",
};

/**
 * Display heading keyed to the homepage typography scale. Renders the tag
 * passed via `as` and applies the compound utility matching `size`.
 *
 * @param {Object} props
 * @param {"hero" | "section" | "row"} props.size - typography scale
 * @param {"h1" | "h2" | "h3"} [props.as] - HTML tag, defaults to "h2"
 * @param {import("react").ReactNode} props.children - heading content
 * @param {string} [props.className] - extra classes (color, margin, etc.)
 * @returns {import("react").ReactElement}
 */
export function Heading(props) {
  const { size, as: Tag = "h2", children, className = "" } = props;

  return <Tag className={`${sizeClasses[size]} ${className}`.trim()}>{children}</Tag>;
}
